'use strict';exports.__esModule = true;var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _ramda = require('ramda');
var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _Constants = require('../../containers/MyStaffContainer/Constants');
var _MyStaffUserFormUpdate = require('./MyStaffUserFormUpdate');var _MyStaffUserFormUpdate2 = _interopRequireDefault(_MyStaffUserFormUpdate);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var mapStateToProps = function mapStateToProps(_, props) {var _initialValues;return {
    form: 'my-staff-user-update-' + props.id,
    initialValues: (_initialValues = {}, _initialValues[
    _Constants.FIELD_NAMES.PUBLISH_LIMIT] = String(props.allowed || 0), _initialValues[
    _Constants.FIELD_NAMES.COLOR_PROMOTION_LIMIT] = String(props.promotion || 0), _initialValues[
    _Constants.FIELD_NAMES.TOP_PROMOTION_LIMIT] = String(props.top_promotion || 0), _initialValues) };};exports.default =



(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps),
(0, _reduxForm.reduxForm)({
  validate: _validate2.default }))(_MyStaffUserFormUpdate2.default);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyStaffUserCard/MyStaffUserForm.js
// module id = 2736
// module chunks = 0